import isTablet from 'is-mobile';

import { Color3 } from '@babylonjs/core/Maths/math.color';

/** Holds basic settings and values to be used by the scene objects. */
export default abstract class Settings {
  public static readonly BLANK_LOGO =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  public static readonly LOADING_SCREEN_COLOR = '#F4F5F8';
  public static readonly BRAND_COLOR: Color3 = new Color3(1, 0.439, 0);
  public static readonly DISCONTINUED_COLOR_READONLY: Color3 = new Color3(1, 0.878, 0.313);
  public static readonly DISCONTINUED_COLOR_EDITABLE: Color3 = new Color3(1, 0.2, 0.2);
  public static readonly SHADOWS_MAP_SIZE = 256;
  public static readonly IS_TABLET = isTablet({ featureDetect: true, tablet: true });
  public static readonly OVERLAY_RENDERING_GROUP = 1;
  public static readonly IDLE_ANIMATION_WAIT_TIME = 180000;
  public static readonly BACKGROUND_COLOR_TONE = 0.6;
  public static readonly SCREENSHOT_CAMERA_VIEW_MASK = 0x08000000;
  public static readonly HIDDEN_ON_SCREENSHOT_CAMERA_MASK = 0x07ffffff;
  public static readonly BUTTON_ZOOM_FACTOR = 4;
}
